<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/86djoT/tc-custom/9781680573725.jpg?1725275608236" alt="This image is the cover for the book Elusive Pimpernel"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Elusive Pimpernel
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A novel of swashbuckling action in the series featuring the classic hero who saves innocents from the guillotine in Revolutionary France . . .</b></p><p><i>“We seek him here! we seek him there!</i></p><p><i>Those Frenchies seek him everywhere!</i></p><p><i>Is he in heaven? Is he in hell?</i></p><p><i>That demmed elusive Pimpernel?”</i></p><p> Sir Percy thought he left his enemy vanquished, humiliated, and debased in Calais. Oh, how foolish he was. Now Chauvelin is bent on revenge . . . </p><p> As punishment for letting the Scarlet Pimpernel escape the clutches of the French Republic, Chauvelin was demoted from the ranks of Robespierre’s trusted few. But he will have his day. Laying a trap for the wife of Sir Percy, Lady Marguerite, is only the first step. </p><p> Can Sir Percy elude the blade of Madame Guillotine a second time, defend his honor as the Scarlet Pimpernel, and save his wife from a fate worse than death? </p><p> Baroness Emma Orczy brings us the third thrilling installment in her iconic adventures of the Scarlet Pimpernel, pitting Sir Percy against the wily Chauvelin once again in a battle of wit and cunning that stands between thousands of innocent lives and the ignominious bite of Madame Guillotine. Credited with the introduction of the “hero with a secret identity” trope, the Scarlet Pimpernel and his exploits have captured the imaginations of readers for over a century. The series housing the most historical accuracies of French Revolution-centric fiction of its time, it also inspired a stage play garnering over 2,000 performances in four years. Join the League of the Scarlet Pimpernel and dive into the rollicking adventures of the masked hero of the French Revolution! </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Baroness Orczy
      </h2>
      
      <p class="authorDescription body article">Baroness Orczy (1865&ndash;1947) was a member of the Hungarian aristocracy, and her family settled in London when she was a teenager. At Heatherley&rsquo;s School of Fine Art, she met her future husband, Montague Barstow, and in 1903 the two collaborated on <I>The Scarlet Pimpernel</I>, a play about an English aristocrat&rsquo;s adventures during the French revolution. The play and its subsequent novelization were great successes, and Orczy went on to write more than a dozen sequels featuring the Pimpernel and many other works of romance and mystery, including <I>The Old Man in the Corner </I>and <I>Lady Molly of Scotland Yard</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      WordFire Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?24d74799